import React from "react";
// import hero data
import { heroData } from "../data";
// import motion
import { motion } from "framer-motion";
// import fadeIn
import { fadeIn } from "../variants";

const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.6,
    },
  },
};

const Hero = () => {
  // destructure hero data
  const { title, subtitle } = heroData;
  return (
<section className="bg-hero bg-cover bg-center min-h-[55vh] lg:h-[940px] bg-no-repeat relative mt-[120px] lg:mt-[150px]">
  <motion.div
    variants={container}
    initial="hidden"
    whileInView={"show"}
    className="container mx-auto min-h-[55vh] lg:h-full flex items-start lg:items-center justify-center xl:justify-end pt-6 lg:pt-0"
  >
    <div className="text-center lg:text-left lg:max-w-[520px]">
      <motion.h1
        variants={fadeIn("down")}
        className="h1 text-dark [text-shadow:_0_0_10px_white,_0_0_20px_white]"
      >
        {title}
      </motion.h1>
      <motion.p
        variants={fadeIn("down")}
        className="mb-8 lg:mb-16 max-w-lg leading-relaxed text-dark [text-shadow:_0_0_8px_white,_0_0_16px_white]"
      >
        {subtitle}
      </motion.p>
    </div>
  </motion.div>
</section>
  );
};

export default Hero;
